<template>
  <Transition 
    enter-active-class="transition-all duration-300 ease-out"
    enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:translate-x-4"
    enter-to-class="opacity-100 translate-y-0 sm:translate-x-0"
    leave-active-class="transition-all duration-300 ease-in"
    leave-from-class="opacity-100 translate-y-0 sm:translate-x-0"
    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:translate-x-4"
  >
    <div 
      v-if="show" 
      class="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 max-w-sm w-full sm:w-96"
    >
      <div 
        class="rounded-lg shadow-lg overflow-hidden"
        :class="{
          'bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-800': type === 'success',
          'bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800': type === 'error'
        }"
      >
        <div class="p-4">
          <div class="flex items-start">
            <div class="flex-shrink-0">
              <svg 
                v-if="type === 'success'" 
                class="h-6 w-6 text-green-400" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
              <svg 
                v-else 
                class="h-6 w-6 text-red-400" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <div class="ml-3 w-0 flex-1 pt-0.5">
              <p class="text-sm font-medium" :class="{
                'text-green-800 dark:text-green-200': type === 'success',
                'text-red-800 dark:text-red-200': type === 'error'
              }">
                {{ message }}
              </p>
              <p v-if="resolution" class="mt-1 text-sm" :class="{
                'text-green-700 dark:text-green-300': type === 'success',
                'text-red-700 dark:text-red-300': type === 'error'
              }">
                {{ resolution }}
              </p>
            </div>
            <div class="ml-4 flex-shrink-0 flex">
              <button 
                @click="$emit('close')" 
                class="inline-flex text-gray-400 hover:text-gray-500 focus:outline-none"
              >
                <span class="sr-only">Close</span>
                <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';

defineProps<{
  show: boolean;
  type: 'success' | 'error';
  message: string;
  resolution?: string;
}>();

defineEmits(['close']);
</script>
